import React from 'react';
import './modalFooter.css'
import "../commonUi/modal.module.sass"
import { Button } from './Button';

interface ModalFooterProps {
   okText: string;
   cancelText: string;
   okCallback: any;
   cancelCallback: any;
   okClassName?: string;
   cancelClassName?: string;
   disableOkButton?: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = (props) => {
    return (
        <div className='cmn_modal_footer'>
            <button onClick={props.cancelCallback} style={{color: "#15808C"}} className={`${props.cancelClassName} mdl_cancel_btn`}>{props.cancelText}</button>
            <Button loading={props.disableOkButton || false} disabled={props.disableOkButton || false} onClick={props.okCallback} className={`${props.disableOkButton ? `modal_footer_loading ${props.okClassName} mdl_ok_btn_loader` : ` ${props.okClassName} mdl_ok_btn_bg`}`}>{props.okText}</Button>
        </div>
    );
};

export default ModalFooter;
